import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import sortImg from "../../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../../picture/redniBrojevi.png";
import notifImg from "../../../../../picture/notification.png";
import deleteImg from "../../../../../picture/delete.png";
import archiveImg from "../../../../../picture/letterA.png";
import arrowImg from "../../../../../picture/PlayLanguage.png";
import Filtriranje from "./Filtriranje";
import Dodavanje from "./Dodavanje";
import Preview from "./Preview";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";
import EyeIcon from "../../../../../picture/Visible.png";

const st = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  smallCell: { width: "30px", textAlign: "center" },
};

function TabelaZaposleni({ currentTab }) {
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentState, setCurrentState] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);
  const [isCheckedSort, setIsCheckedSort] = useState(false);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [lookups, setLookups] = useState({ zaposleni: [], radna_mesta: [] });

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija5/read.php`, {
        company_id: selectedMainEntity.company_id,
      });
      if (data.status === 200) {
        setAllData(data.data);
        setFilteredData(data.data);
      }
    } catch (e) { console.error(e); }
  };

  const fetchLookups = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija5/get_lookups.php`, {
        company_id: selectedMainEntity.company_id,
      });
      if (data.status === 200) setLookups(data);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
    fetchLookups();
    setCurrentState("");
  }, [selectedMainEntity, currentTab]);

  const handleCheckSort = () => {
    setIsCheckedSort(prev => !prev);
    setFilteredData(prev => [...prev].reverse());
  };

  const handleCheckRow = (id) => {
    setCheckedRows(prev => prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]);
  };

  const handleCheckAll = () => {
    setCheckedRows(isCheckedAll ? [] : filteredData.map(z => z.id));
    setIsCheckedAll(prev => !prev);
  };

  const handleDelete = async (id) => {
    try {
      await axios.post(`${baseUrl}/evidencija5/delete.php`, { id });
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleZatvori = () => { setSelectedRow(null); setCurrentState(""); };

  if (currentState === "PREVIEW" && selectedRow)
    return <Preview data={filteredData} selectedRow={selectedRow} cancel={handleZatvori} onRefresh={fetchData} />;

  if (currentState === "DODAVANJE")
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "90%" }}>
        <Dodavanje handleZatvori={handleZatvori} sacuvajAzurirano={fetchData} lookups={lookups} />
      </div>
    );

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "90%" }}>
      <div style={{
        overflowY: "auto",
        height: `calc(100% - ${currentState === "FILTRIRANJE" ? "140" : "60"}px)`,
        backgroundColor: "white", padding: "5px", border: "1.5px solid #9f9f9f"
      }}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={st.smallCell}>
                <input type="checkbox" checked={isCheckedAll} onChange={handleCheckAll} style={{ width: "25px" }} />
              </th>
              <th style={{ width: "80px" }}>
                <div style={{ display: "flex" }}>
                  <div onClick={handleCheckSort}><Button active={isCheckedSort}><img src={sortImg} style={{ width: "40px", height: "30px" }} /></Button></div>
                  <div onClick={() => setIsCheckedRedniBrojevi(p => !p)}><Button active={isCheckedRedniBrojevi}><img src={redniBrojeviImg} style={{ width: "40px", height: "30px" }} /></Button></div>
                </div>
              </th>
              <th style={st.cell}>{dictionary["imeIPrezime"]}</th>
              <th style={st.cell}>{dictionary["radnoMesto"]}</th>
              <th style={st.cell}>NAZIV KARCINOGENA</th>
              <th style={st.cell}>TIP PREGLEDA</th>
              <th style={st.cell}>IZVRŠEN</th>
              <th style={st.cell}>SLEDEĆI</th>
              <th style={st.smallCell}><img src={notifImg} style={{ width: "25px" }} /></th>
              <th style={st.cell}></th>
              <th style={st.cell}></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, i) => (
              <tr key={item.id}>
                <td style={st.cell}>
                  <input type="checkbox" checked={checkedRows.includes(item.id)} onChange={() => handleCheckRow(item.id)} style={{ width: "25px" }} />
                </td>
                <td style={st.cell}>{isCheckedRedniBrojevi ? item.id : i + 1}.</td>
                <td style={st.cell}>{item.ime_prezime}</td>
                <td style={st.cell}>{item.workplace_name}</td>
                <td style={st.cell}>{item.naziv}</td>
                <td style={st.cell}>{item.tip_pregleda}</td>
                <td style={st.cell}>{item.datum_pregleda}</td>
                <td style={st.cell}>{item.datum_sledeci}</td>
                <td style={st.cell}>
                  <div style={{ width: "25px", height: "25px", margin: "0 auto", backgroundColor: item.notification_color || "" }} />
                </td>
                <td onClick={() => { setSelectedRow(item); setCurrentState("PREVIEW"); }} style={st.smallCell}>
                  <img src={EyeIcon} style={{ width: "30px", cursor: "pointer" }} />
                </td>
                <td onClick={() => handleDelete(item.id)} style={st.smallCell}>
                  <img src={deleteImg} style={{ width: "20px", cursor: "pointer" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {currentState === "FILTRIRANJE" && (
        <Filtriranje setCurrentState={setCurrentState} setFilteredData={setFilteredData} allData={allData} lookups={lookups} />
      )}

      <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
        <div style={{ fontWeight: "bold" }}>
          <div style={{ fontSize: "14px" }}>{filteredData.length}</div>
          <div style={{ fontSize: "14px" }}>{dictionary["unos"]}</div>
        </div>
        <div style={{ height: "40px" }}>
          <Button activation={true}><span style={{ width: "15vw", fontWeight: "bold" }}>{dictionary["stampaj"]}</span></Button>
        </div>
        <div style={{ width: "15vw", height: "40px" }}>
          <Button activation={true}><span style={{ fontWeight: "bold" }}>{dictionary["posalji"]}</span></Button>
        </div>
        <div onClick={() => setCurrentState(p => p === "FILTRIRANJE" ? "" : "FILTRIRANJE")} style={{ width: "15vw", height: "40px" }}>
          <Button active={currentState === "FILTRIRANJE"}><span style={{ fontWeight: "bold" }}>{dictionary["filtriraj"]}</span></Button>
        </div>
        <div onClick={() => setCurrentState("DODAVANJE")} style={{ width: "15vw", height: "40px" }}>
          <Button activation={true}><span style={{ fontWeight: "bold" }}>{dictionary["dodaj"]}</span></Button>
        </div>
      </div>
    </div>
  );
}

export default TabelaZaposleni;